import { render } from "./profile-identification-legal.vue?vue&type=template&id=531c4011&scoped=true&ts=true"
import script from "./profile-identification-legal.vue?vue&type=script&lang=ts"
export * from "./profile-identification-legal.vue?vue&type=script&lang=ts"

import "./profile-identification-legal.vue?vue&type=style&index=0&id=531c4011&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531c4011"]])

export default __exports__